// Concert pitch: A4 is 440 Hz and MIDI note 69, the anchor for every frequency <-> semitone conversion.
export const A4_FREQUENCY_HZ = 440;
export const A4_MIDI_NOTE = 69;
